import { createFeatureSelector, createSelector } from '@ngrx/store';
import { TicketingState } from 'src/app/root-store/ticket-store/state/ticketing.state';
import { ticketStoreFeatureKey } from 'src/app/root-store/ticket-store/ticket-store.reducers';

export const selectTicketingFeature = createFeatureSelector<TicketingState>(ticketStoreFeatureKey);

export const selectTicketLoading = createSelector(selectTicketingFeature, (state) => state.loading);

export const selectTicketTaskNoteHistory = createSelector(
    selectTicketingFeature,
    (state) => state.ticketTaskNoteHistory
);

export const selectTicketDetails = createSelector(selectTicketingFeature, (state) => state.ticketDetails);

export const selectIsForbidden = createSelector(selectTicketingFeature, (state) => state.isForbidden);

export const selectTicketCounsels = createSelector(selectTicketingFeature, (state) => state.counsels);

export const selectTicketTypes = createSelector(selectTicketingFeature, (state) => state.ticketTypes);

export const selectTicketCategories = createSelector(selectTicketingFeature, (state) => state.categories);

export const selectCandidates = createSelector(selectTicketingFeature, (state) => state.candidates);

export const selectStates = createSelector(selectTicketingFeature, (state) => state.states);

export const selectUrgency = createSelector(selectTicketingFeature, (state) => state.urgency);

export const selectTagTypes = createSelector(selectTicketingFeature, (state) => state.tagTypes);
export const selectTagTypesForCategory = createSelector(selectTicketingFeature, (state) => state.tagTypesForCategory);

export const selectCandidateContracts = createSelector(selectTicketingFeature, (state) => state.candidateContracts);

export const selectTicketUpdatingFlag = createSelector(selectTicketingFeature, (state) => state.isUpdating);

export const selectTicketHistory = createSelector(selectTicketingFeature, (state) => state.ticketHistory);

export const selectTicketTasks = createSelector(selectTicketingFeature, (state) => state.ticketTasks);

export const selectTicketEmployees = createSelector(selectTicketingFeature, (state) => state.employees);

export const selectTicketContract = createSelector(selectTicketingFeature, (state) => state.contract);

export const selectTravelContract = createSelector(selectTicketingFeature, (state) => state.travelContract);

export const selectContractLookup = createSelector(selectTicketingFeature, (state) => state.contractLookup);

export const selectTicketAttachments = createSelector(selectTicketingFeature, (state) => state.ticketAttachments);

export const selectTicketSettingsCategories = createSelector(
    selectTicketingFeature,
    (state) => state.settingsCategories
);

export const selectTicketCategoryTypes = createSelector(selectTicketingFeature, (state) => state.categoryTypes);
